<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }} <strong>{{ qiJobNumber }}</strong>
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>สถานะการดำเนินการ :</strong></label>
                <span class="form-control-plaintext" v-html="qiStatusName"></span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>เลขที่ใบเบิกสินค้า :</strong></label>
                <span class="form-control-plaintext" v-html="refCode"></span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class=" mb-0"><strong>วันที่สร้าง :</strong></label>
                <span class="form-control-plaintext">{{ createdDate }}</span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>ผู้ดำเนินการ :</strong></label>
                <span class="form-control-plaintext">{{ createdUserName }}</span>
              </div>
            </div>
          </div>

          <div class="kt-section kt-section--first">
            <div class="kt-section__body">
              <label class="label mb-0"><strong>ข้อมูลรับเข้าอะไหล่ :</strong></label>
              <span class="form-text mb-3"></span>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-sm table-striped table-bordered table-checkable">
                    <thead>
                      <tr class="table-warning">
                        <th class="text-center">ลำดับ</th>
                        <th class="text-center">รายการอะไหล่</th>
                        <th class="text-center">จำนวน</th>
                        <th class="text-center">หน่วย</th>
                        <th class="text-center">หมายเหตุ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="items.length === 0">
                        <td class="text-center" colspan="5">ไม่พบข้อมูลรายการอะไหล่</td>
                      </tr>
                      <tr v-else v-for="(item, index) in items" :key="item.qiJobItemId">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ item.materialNameShow }}</td>
                        <td class="text-center">{{ formatNumber(item.quantity) }}</td>
                        <td class="text-center">{{ item.baseUnit }}</td>
                        <td>{{ item.remark }}</td>
                      </tr>
                      <tr>
                        <td class="text-right" colspan="2"><strong>จำนวนรวม</strong></td>
                        <td class="text-center"><strong>{{ formatNumber(totalQuantity) }}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import router from "../../router";

export default {
  data: function() {
    var self = this;
    return {
      qiJobId: null,
      qiJobNumber: null,
      qiStatusName: null,
      refCode: '',
      createdDate: null,
      createdUserName: null,
      finishedDate: null,
      qiTypeName: null,
      materialNameShow: null,
      amount: null,
      items: [],
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/QIJobs/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          //console.log(response.data);
          if (response.data != null) {
            self.qiJobId = response.data.qiJobId;
            self.qiJobNumber = response.data.qiJobNumber ? `เลขที่ใบงาน : ${response.data.qiJobNumber}` : '';
            self.refCode = response.data.refCode;
            self.qiStatusName = response.data.qiStatusName;
            self.createdDate = response.data.createdDateFormat ? response.data.createdDateFormat : '-';
            self.createdUserName = response.data.createdUserName ? response.data.createdUserName : '-';
            self.finishedDate = response.data.finishedDate ? self.setDateFormat(response.data.finishedDate, true) : '-';
            self.amount = response.data.amount ? response.data.amount : '-';

            if (response.data.items && Array.isArray(response.data.items)) {
              self.amount = response.data.items.reduce((total, item) => total + item.quantity, 0);
              self.items = response.data.items;
            }

          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลใบงานช่างซ่อมคุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลใบงานช่างซ่อมได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
    methods: {
       
    formatNumber(value) {
        if (value == null || value === '') return '-';
        return Number(value).toLocaleString('en-US');
    }
        
    ,
    setDateFormat(dateStr, includeTime = false) {
      let options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        calendar: 'gregory'
      };
      if (includeTime) {
        options = {
          ...options,
          hour: '2-digit',
          minute: '2-digit'
        };
      }
      let dateStrFormat = new Date(dateStr).toLocaleDateString('th-TH', options);
      return dateStrFormat;
    },
  },
  computed: {
    totalQuantity() {
      return this.items.reduce((sum, item) => sum + item.quantity, 0);
    }
  }
};
</script>
<style lang="css">
.border-dashed {
  border: 1px dashed;
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// App/Components/QIJob/QIRecvDetail.vue